import React from "react";
import MuiAutocomplete from "@mui/material/Autocomplete";

import {
  useAutocompleteMediumStyles,
  useAutocompleteSmallStyles,
} from "./AutocompleteStyles";
import { AutocompleteProps } from "./Autocomplete.types";

function Autocomplete(props: AutocompleteProps): JSX.Element {
  const { size } = props;

  const classesMedium = useAutocompleteMediumStyles();
  const classesSmall = useAutocompleteSmallStyles();

  return (
    <MuiAutocomplete
      {...props}
      classes={size === "small" ? classesSmall : classesMedium}
    />
  );
}

export default Autocomplete;
